import React, { useCallback } from 'react';

import AnalyticsContext from '@atlaskit/analytics-next/AnalyticsContext';

import { useEditionAwareness } from '../../services/edition-awareness-context';
import { useGetExperimentValue } from '../../services/experiment-context';
import { isEligibleForEAtoOSBNonRTPremiumAndRTPredunning } from '../../services/is-eligible-for-ea-to-osb-nonrt-premium-and-rt-predunning';
import type { LinkConfig } from '../dialogs/shared/types';
import { EditionAwarenessLink } from '../edition-awareness-button';

export const LINK_CONFIG: LinkConfig = {
	linkId: 'payment-flow',
	touchpointIntent: 'addPaymentDetails',
};

interface PaymentFlowLinkProps {
	href: string;
}

const PaymentFlowLinkContent = ({ href }: PaymentFlowLinkProps): React.JSX.Element => {
	const context = useEditionAwareness();
	const { getExperimentCohort } = useGetExperimentValue();

	const handlePaymentFlowClick = useCallback(() => {
		if (isEligibleForEAtoOSBNonRTPremiumAndRTPredunning(context)) {
			getExperimentCohort('ea-to-osb-nonrt-premium-rt-predunning-ab');
		}
	}, [context, getExperimentCohort]);

	return (
		<EditionAwarenessLink
			href={href}
			target="_blank"
			onClick={handlePaymentFlowClick}
			{...LINK_CONFIG}
		/>
	);
};

export const PaymentFlowLink = (): React.JSX.Element => {
	const { addPaymentDetailsExperienceUrl } = useEditionAwareness();

	if (addPaymentDetailsExperienceUrl) {
		return (
			<AnalyticsContext data={LINK_CONFIG}>
				<PaymentFlowLinkContent href={addPaymentDetailsExperienceUrl} />
			</AnalyticsContext>
		);
	}
	return <></>;
};
